import * as uuid from "uuid"

export const newUuid = () => uuid.v4()
